module.exports = __webpack_public_path__ + "static/media/header-appStore.29aecd7a.svg";